/**
 * frontend/src/constants/monitoringUrls.js
 *
 * Два контура на домене monitoring.markbase.ru (не смешивать в nginx server_name):
 *
 * 1) CORE_monitoring (№48) — markbaseCORE, FastAPI :8063, hot telemetry + operator HTML.
 *    Прод: `markbaseCORE/nginx-system-configs/.../monitoring.markbase.ru-proxy.conf` → 127.0.0.1:8063.
 *
 * 2) PROCESS_CENTER (№35) — markbase.ru/modouls/PROCESS_CENTER, Node :8103, процессы/очереди.
 *    Embedded Super-Admin SPA в App; API через `markbase.ru/nginx/conf.d/monitoring.markbase.conf`
 *    → `monitoring-backend:8103` (`/api/monitoring/v1` для processes, не server metrics).
 *
 * Этот файл — URL для embed PROCESS_CENTER (контур 2). Системные метрики/логи/дашборд — контур 1 (CORE).
 * Доступ: Super Admin (`PERMISSIONS.ADMIN_ACCESS`) / platform_admin на CORE dashboard.
 *
 * Переопределение через env (build-time):
 * - `REACT_APP_MONITORING_PUBLIC_URL` — origin PROCESS_CENTER SPA (не CORE dashboard).
 * - `REACT_APP_MONITORING_MODULE_URL` — точка входа iframe (например `/processes`).
 * - `REACT_APP_MONITORING_API_URL` — префикс API PROCESS_CENTER (8103), если не `{origin}/api/monitoring/v1`.
 */

export const MONITORING_ORIGIN = (
  process.env.REACT_APP_MONITORING_PUBLIC_URL || 'https://monitoring.markbase.ru'
).replace(/\/+$/, '');

export const MONITORING_API_BASE =
  process.env.REACT_APP_MONITORING_API_URL || `${MONITORING_ORIGIN}/api/monitoring/v1`;

/**
 * Корень веб-приложения PROCESS_CENTER для EmbeddedModule (iframe).
 * По умолчанию — корень origin: SPA сама делает дефолтный роут на `/` (Процессы).
 */
export const MONITORING_MODULE_ROOT_URL =
  process.env.REACT_APP_MONITORING_MODULE_URL || `${MONITORING_ORIGIN}/`;

/**
 * CORE_monitoring (№48) — FastAPI markbaseCORE :8063, hot telemetry + operator HTML.
 * Не путать с MONITORING_* выше (PROCESS_CENTER Node :8103 на том же домене через nginx routing).
 */
export const CORE_MONITORING_ORIGIN = (
  process.env.REACT_APP_CORE_MONITORING_PUBLIC_URL || 'https://monitoring.markbase.ru'
).replace(/\/+$/, '');

export const CORE_MONITORING_API_BASE =
  process.env.REACT_APP_CORE_MONITORING_API_URL ||
  `${CORE_MONITORING_ORIGIN}/api/monitoring/v1`;

export const CORE_MONITORING_DASHBOARD_URL = `${CORE_MONITORING_ORIGIN}/dashboard`;
